export function gotoSignup() {
  gaEvent('buttons', 'signup-click');
  //ga('send', 'event', 'buttons', 'login-click');
  //ga('send', 'event', 'mailinglist', 'submitted');
  window.location.href = 'https://app.bundlecop.com';
}


export function gaEvent(category, action) {
  if (process.env.NODE_ENV === `production` && typeof ga === `function`) {
    ga('send', 'event', category, action);
  }
}


// WEBPACK FOOTER //
// ./src/utils/ga.js